module.exports = __webpack_public_path__ + "media/images/emoticons/annoy-4ed03316b6cd7922ee6f924001cea5a5.gif";